import { LazyWrapper } from '@halo/ui-react';
import type { TreeRelation } from '@halo/utils';
import { toTree } from '@halo/utils';
import AccessPage from '@/components/AccessPage';
import ErrorPage from '@/pages/error';
import type { RouteItem } from './types';

export function genRoutes(relation: TreeRelation<RouteItem>) {
  return toTree(relation, ({ element, menu, auth, errorElement, ...item }) => {
    const element_ = <LazyWrapper>{element}</LazyWrapper>;
    return {
      element: auth ? <AccessPage authKey={auth.key}>{element_}</AccessPage> : element_,
      errorElement: errorElement || <ErrorPage />,
      ...item,
    };
  });
}
